import styles from '../../styles/emailTemplateCard.module.css'
import { cn } from '@/lib/utils/helpers'
import type { EmailTemplateAddEditFormProps } from '../../types/components'
import { EmailTemplateFieldError } from './EmailTemplateFieldError'
import { EmailTemplateFormSection } from './EmailTemplateFormSection'

export function EmailTemplateInfoSection({ page }: EmailTemplateAddEditFormProps) {
  const { errors, registerField, showFieldError, fieldErrorMessage } = page

  return (
    <EmailTemplateFormSection testId="et-section-template-info" title="Template information">
      <div className={styles.formRow}>
        <div className={cn(styles.formCol, styles.formColHalf, 'min-w-0')}>
          <div className={styles.formGroup}>
            <label className={styles.formLabel} htmlFor="et-name">
              Template name <span className={styles.requiredStar}>*</span>
            </label>
            <input
              id="et-name"
              className={cn(
                styles.customFormControl,
                errors.template_name && '!border-red-500',
              )}
              placeholder="Template name *"
              {...registerField('template_name')}
            />
            <EmailTemplateFieldError
              show={showFieldError('template_name')}
              message={fieldErrorMessage('template_name')}
              testId="et-field-error-name"
            />
          </div>
        </div>
        <div className={cn(styles.formCol, styles.formColHalf, 'min-w-0')}>
          <div className={styles.formGroup}>
            <label className={styles.formLabel} htmlFor="et-desc">
              Template description <span className={styles.requiredStar}>*</span>
            </label>
            <textarea
              id="et-desc"
              rows={3}
              className={cn(
                styles.customFormControl,
                errors.template_description && '!border-red-500',
              )}
              placeholder="Template description *"
              {...registerField('template_description')}
            />
            <EmailTemplateFieldError
              show={showFieldError('template_description')}
              message={fieldErrorMessage('template_description')}
              testId="et-field-error-description"
            />
          </div>
        </div>
      </div>
    </EmailTemplateFormSection>
  )
}
